<div class="stepper">
  @for (phase of phases$ | async; track $index) {
    <app-phase-container
      [phase]="phase"
      [phaseIndex]="$index"
      [phases]="(phases$ | async) ?? []"
      (stepClick)="onStepClick($event)"
    />
  }
</div>
